module.exports = __webpack_public_path__ + "static/media/3.af5281cb.jpg";